import React, { useState, useEffect } from "react";
import { Autocomplete, TextField, Box, IconButton } from "@mui/material";
import CachedIcon from "@mui/icons-material/Cached";
import LinkIcon from "@mui/icons-material/Link";
import { UseProductType } from "./UseProductType";

export default function TypeAutoComplete(props) {
  const { getAllProductTypeList } = UseProductType();
  const [productTypeRes, setProductTypeRes] = React.useState();
  const [selectedType, setSelectedType] = React.useState();

  useEffect(() => {
    getAllProductTypeList((productTypes) => {
      setProductTypeRes(productTypes);
    });
  }, []);

  useEffect(() => {
    if (productTypeRes && props.selectedTypeID) {
      setSelectedType(
        productTypeRes.productTypes.find((m) => m.id == props.selectedTypeID)
      );
    }
  }, [productTypeRes, props.selectedTypeID]);

  useEffect(() => {
    if (selectedType) {
      if (props.cluster) {
        props.setter({
          ...props.lvl2State,
          productTypeID: selectedType.id,
        });
        return;
      }
      props.setter({
        ...props.lvl2State,
        typeID: selectedType.id,
      });
    }
  }, [selectedType]);

  return productTypeRes ? (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        width: props.cluster && "100%",
      }}
    >
      <Autocomplete
        value={selectedType ? selectedType : ""}
        id="combo-box-demo"
        options={productTypeRes.productTypes ? productTypeRes.productTypes : []}
        getOptionLabel={(productType) =>
          productType.faName ? productType.faName : ""
        }
        isOptionEqualToValue={(option, value) => option.value === value.value}
        renderInput={(params) => (
          <TextField error={props.validation} {...params} label="نوع محصول" />
        )}
        renderOption={(props, option) => {
          return (
            <li {...props} key={option.id}>
              {option.faName ? option.faName : ""}
            </li>
          );
        }}
        onChange={(evt, newValue) => {
          if (newValue) {
            setSelectedType(newValue);
          } else {
            setSelectedType();
            props.setter({
              ...props.lvl2State,
              typeID: 0,
            });
          }
        }}
        fullWidth
        size="small"
      />
      <IconButton
        sx={{ p: 0, m: 1 }}
        onClick={() => {
          getAllProductTypeList((productTypes) => {
            setProductTypeRes(productTypes);
          });
        }}
      >
        <CachedIcon fontSize="small" />
      </IconButton>
      <IconButton sx={{ p: 0 }} href="/producttypes" target="_blank">
        <LinkIcon fontSize="small" />
      </IconButton>
    </Box>
  ) : (
    ""
  );
}
